import { render } from "./IconWrapper.vue?vue&type=template&id=48d323a0&scoped=true"
import script from "./IconWrapper.vue?vue&type=script&lang=js"
export * from "./IconWrapper.vue?vue&type=script&lang=js"

import "./IconWrapper.vue?vue&type=style&index=0&id=48d323a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d323a0"]])

export default __exports__